import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { estimateStrength } from "utils/password";

type BarColor = "error" | "warning" | "info" | "success";

const SCORE_COLOR: BarColor[] = [
  "error",
  "error",
  "warning",
  "info",
  "success",
];

interface PasswordStrengthMeterProps {
  password: string;
  personalTerms?: Array<string | undefined | null>;
}

const PasswordStrengthMeter: React.FC<PasswordStrengthMeterProps> = ({
  password,
  personalTerms = [],
}) => {
  const { t } = useTranslation();

  if (!password) return null;

  const { score } = estimateStrength(password, personalTerms);

  const labels = [
    t("password_policy.strength.very_weak"),
    t("password_policy.strength.weak"),
    t("password_policy.strength.fair"),
    t("password_policy.strength.good"),
    t("password_policy.strength.strong"),
  ];

  const color = SCORE_COLOR[score];

  return (
    <Box sx={{ mt: 0.5 }}>
      <LinearProgress
        variant="determinate"
        value={((score + 1) / 5) * 100}
        color={color}
        sx={{ height: 6, borderRadius: 3 }}
      />
      <Box display="flex" justifyContent="space-between" mt={0.5}>
        <Typography variant="caption" color="textSecondary">
          {t("password_policy.strength.label")}
        </Typography>
        <Typography variant="caption" color={`${color}.main`}>
          {labels[score]}
        </Typography>
      </Box>
    </Box>
  );
};

export default PasswordStrengthMeter;
